import { AUTH_ROUTE_NAME } from "@/libs/route-name";

export const forgotPasswordRoute = () => {
    return {
        name: AUTH_ROUTE_NAME.FORGOT_PASSWORD,
        path: "/forgot-password",
        component: () => import("@/pages/auth/forgot-password.vue"),
    }
}